import React from "react";
import { Modal } from "react-bootstrap";
import dateFormat from "dateformat";
import DashMedidasButton from "./DashMedidasButton/DashMedidasButton";

const MeasurePointActionModal = ({
  show,
  measure,
  onHide,
  onOpenCalculations,
  onOpenDatasetDetails,
}) => {
  const titleDate = measure?.date
    ? dateFormat(measure.date, "UTC:dd/mm/yy' 'HH:MM")
    : null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="dash-metadata-modal__dialog"
      className="dash-medidas-modal dash-metadata-modal dash-point-action-modal"
    >
      <Modal.Header closeButton className="dash-metadata-modal__header">
        <Modal.Title className="dash-metadata-modal__title">
          Escolha uma ação
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="dash-metadata-modal__body">
        <p className="dash-point-action-modal__lead mb-2">
          Esta medição possui informações de dataset.
        </p>
        {titleDate ? (
          <p className="dash-metadata-modal__datetime mb-3">{titleDate}</p>
        ) : null}
        <p className="dash-point-action-modal__hint mb-0">
          Inclua ou remova o ponto da seleção para análise e cálculos, ou abra os
          detalhes completos do dataset.
        </p>
      </Modal.Body>
      <Modal.Footer className="dash-metadata-modal__footer dash-point-action-modal__footer">
        <DashMedidasButton variant="outline-secondary" onClick={onHide}>
          Cancelar
        </DashMedidasButton>
        <DashMedidasButton variant="outline-success" onClick={onOpenDatasetDetails}>
          Ver detalhes do dataset
        </DashMedidasButton>
        <DashMedidasButton variant="success" onClick={onOpenCalculations}>
          Abrir cálculos
        </DashMedidasButton>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(MeasurePointActionModal);
